import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { useFilterState } from './useFilterState';

// Page Size Options
export const defaultViewPerPageOptions = [
	{ label: 24, value: 24 },
	{ label: 48, value: 48 },
	{ label: 72, value: 72 },
	{ label: 120, value: 120 }
];

const useFilters = () => {
	const { t } = useTranslation();
	const location = useLocation();
	const [filtersLoading, setFiltersLoading] = useState(false);
	const [filters, setFilters] = useState([]);

	const { filtersUrl, sortingOption, viewPerPageOption, page } = useFilterState(location);

	const [viewPerPageOptions, setViewPerPageOptions] = useState(defaultViewPerPageOptions);

	// Sorting Options
	const gridSortOptions = [
		{ label: t('sort_option1'), value: 'name asc' },
		{ label: t('sort_option2'), value: 'name desc' },
		{ label: t('sort_option3'), value: 'cdate desc' },
		{ label: t('sort_option4'), value: 'price asc' },
		{ label: t('sort_option5'), value: 'price desc' }
	];

	const [filtersModalVisible, setFiltersModalVisible] = useState(false);

	// Handle to add "View all" Option
	const handleSetViewAllProductsOption = (productsCount, minProductsCount, maxProductsCount, optionLabel) => {
		if (productsCount >= minProductsCount && productsCount <= maxProductsCount) {
			setViewPerPageOptions([...defaultViewPerPageOptions, { label: optionLabel, value: productsCount }]);
			return;
		}

		setViewPerPageOptions(defaultViewPerPageOptions);
	};

	return {
		filters,
		filtersUrl,
		page,
		filtersLoading,
		viewPerPageOptions,
		viewPerPageOption,
		gridSortOptions,
		sortingOption,
		filtersModalVisible,
		setFilters,
		setFiltersLoading,
		handleSetViewAllProductsOption,
		setFiltersModalVisible
	};
};

export default useFilters;
